
import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    id: {
      type: Number
    },
    title: {
      type: String
    },
    check: {
      type: Boolean
    }
  },
  setup(props, { emit }) {
    const id = props.id
    let border = ref(false)
    const logo = require('@/assets/img/icons/no-check.svg')

    const isChecked = () => {
      emit('selectedMe', id)
    }

    return {
      isChecked,
      logo,
      border
    }
  }
})
